import React, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import { CSSTransitionGroup } from '../../../../node_module_clones/react-transition-group';

import Button from '../../../components/buttons/Button';
import Icon from '../../../components/icons/Icon';

import BoardTemplatePickerCategory from './BoardTemplatePickerBodyCategory';
import BoardTemplatePickerCategoriesList from './BoardTemplatePickerBodyCategoriesList';
import BoardTemplatePickerDefault from './BoardTemplatePickerBodyDefault';

import './BoardTemplatePickerBody.scss';

const NavigateBackButton = ({ onClickFn }) => (
    <Button className="header-nav back-button" onClickFn={onClickFn}>
        <Icon name="chevron-left" />
        Back
    </Button>
);

NavigateBackButton.propTypes = {
    onClickFn: PropTypes.func,
};

const CloseButton = ({ handleCloseButton }) => (
    <Button className="close-button" onClickFn={handleCloseButton}>
        <Icon name="close-x" />
    </Button>
);

CloseButton.propTypes = {
    handleCloseButton: PropTypes.func,
};

const BoardTemplatePickerBody = ({
    selectedTemplateId,
    navigation,
    setNavigation,
    handleCloseButton,
    selectTemplate,
    ...rest
}) => {
    const lastNav = useRef(navigation);
    const scrollPosition = useRef(0);

    const setScrollPosition = (scroll) => {
        scrollPosition.current = scroll;
    };

    useEffect(() => {
        if (selectedTemplateId) selectTemplate(null);
    }, [navigation]);

    let headerNav;
    let content;
    let transition;

    if (navigation && navigation.startsWith('category:')) {
        headerNav = <NavigateBackButton key="back" onClickFn={() => setNavigation('categories')} />;

        content = (
            <BoardTemplatePickerCategory
                {...rest}
                key={navigation}
                navigation={navigation}
                selectedTemplateId={selectedTemplateId}
                selectTemplate={selectTemplate}
                setNavigation={setNavigation}
            />
        );

        transition = 'slide-left';
    } else if (navigation === 'categories') {
        headerNav = <NavigateBackButton key="back" onClickFn={() => setNavigation('default')} />;

        content = (
            <BoardTemplatePickerCategoriesList
                {...rest}
                key={navigation}
                scrollPosition={scrollPosition.current}
                setScrollPosition={setScrollPosition}
                navigation={navigation}
                selectedTemplateId={selectedTemplateId}
                selectTemplate={selectTemplate}
                setNavigation={setNavigation}
            />
        );

        const lastNavState = lastNav.current || '';
        transition = lastNavState.startsWith('category:') ? 'slide-right' : 'slide-left';
    } else {
        headerNav = (
            <h3 className="header-nav" key="default">
                Choose a template
            </h3>
        );

        content = (
            <BoardTemplatePickerDefault
                {...rest}
                key={navigation}
                navigation={navigation}
                selectedTemplateId={selectedTemplateId}
                selectTemplate={selectTemplate}
                setNavigation={setNavigation}
            />
        );

        transition = 'slide-right';
    }

    lastNav.current = navigation;

    return (
        <div className="BoardTemplatePickerBody">
            <div className="picker-header">
                <CSSTransitionGroup
                    transitionName={transition}
                    transitionEnterTimeout={400}
                    transitionLeaveTimeout={400}
                >
                    {headerNav}
                </CSSTransitionGroup>

                <CloseButton handleCloseButton={handleCloseButton} />
            </div>

            <div className="picker-body-container">
                <CSSTransitionGroup
                    transitionName={transition}
                    transitionEnterTimeout={400}
                    transitionLeaveTimeout={400}
                >
                    {content}
                </CSSTransitionGroup>
            </div>
        </div>
    );
};

BoardTemplatePickerBody.propTypes = {
    selectedTemplateId: PropTypes.string,
    navigation: PropTypes.string,
    setNavigation: PropTypes.func,
    selectTemplate: PropTypes.func,
    handleCloseButton: PropTypes.func,
};

export default BoardTemplatePickerBody;
